import type { ReactNode } from 'react';
import { SLEEK_PILL_SURFACE } from '../../../modules/theme';

// Shared flat pill shell for the sleek header's buttons. Owns the surface,
// height rhythm (h-10 → @[600px] h-11), text style and hover. Horizontal
// padding differs per pill, so callers pass it via `className`.
const PILL_SHELL =
  SLEEK_PILL_SURFACE +
  ' inline-flex items-center justify-center cursor-pointer whitespace-nowrap font-semibold ' +
  'h-10 text-[14px] tracking-[-0.15px] ' +
  '@[600px]:h-11 @[600px]:text-[15px] @[600px]:tracking-[-0.3px] ' +
  'transition-opacity hover:opacity-90';

export interface HeaderPillButtonProps {
  // `| undefined` so callers can forward their own optional onClick under
  // exactOptionalPropertyTypes without a conditional spread.
  onClick?: (() => void) | undefined;
  ariaLabel?: string | undefined;
  /** Per-pill horizontal padding (and any other overrides). */
  className?: string | undefined;
  children: ReactNode;
}

/**
 * Pill primitive shared by {@link LoginPill} and {@link MyPacksPill}.
 * Both render the identical flat shell — only the padding and contents
 * differ — so the shell lives here once.
 */
export function HeaderPillButton({
  onClick,
  ariaLabel,
  className = '',
  children,
}: HeaderPillButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      className={PILL_SHELL + (className ? ' ' + className : '')}
    >
      {children}
    </button>
  );
}
